module.exports = __webpack_public_path__ + "img/guide-cod-3.ad490d57.png";